import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import PropTypes from 'prop-types';
import API from '../services/api';
import { PAGE_ROUTE } from '../constants';

PrivateRoute.propTypes = {
  client: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  isPrivate: PropTypes.bool,
};

PrivateRoute.defaultProps = {
  isPrivate: false,
};

export default function PrivateRoute({ component: Component, client: Client, ...rest }) {

  function Render(props) {
    const token = sessionStorage.getItem('token');
    const decoded = jwt.decode(token);
    if (decoded) {
      const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', decoded.uid));
      switch (profile_id) {
        case 1: return (<Component {...props} />);
        case 2: return (<Component {...props} />);
        default: return (<Client {...props} />);
      }
    } else {
      return (<Redirect to={{ pathname: PAGE_ROUTE.SIGNIN, state: { from: props.location } }} />);
    }
  }

  return (<Route {...rest} render={Render} />);
};
